// src/app/redux/features/callPopup/callPopupSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isCallPopupOpen: false,
};

 const callPopupSlice = createSlice({
  name: 'callPopup', // This name is used in action type prefixes
  initialState,
  reducers: {
    open(state) {
      state.isCallPopupOpen = true;
    },
    close(state) {
      state.isCallPopupOpen = false;
    },

  },
});

// Export the auto-generated action creators
export const { open: openCallPopup, close: closeCallPopup } = callPopupSlice.actions;

// Export the reducer function generated by createSlice
export default callPopupSlice.reducer;